// MobileMenu.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SubMenu from './SubMenu';

const MobileMenuItem = ({ item, toggleMainMenu }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  // Toggle submenu function
  const toggleSubmenu = () => setIsOpen(!isOpen);
  
  if (item.submenu) {
    return (
      <div className="border-b border-gray-100 last:border-0">
        <button 
          onClick={toggleSubmenu}
          className="flex items-center justify-between w-full px-4 py-3 text-gray-800 hover:bg-gray-50 transition-colors duration-300"
          aria-expanded={isOpen}
        >
          <span className="font-medium">{item.label}</span>
          <svg 
            className={`w-4 h-4 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        
        {isOpen && (
          <div className="bg-gray-50 animate-fade-in-down">
            <SubMenu items={item.submenu} isMobile={true} toggleMainMenu={toggleMainMenu} />
          </div>
        )}
      </div>
    );
  }
  
  return (
    <div className="border-b border-gray-100 last:border-0">
      <Link 
        to={item.path}
        className="block px-4 py-3 text-gray-800 hover:bg-gray-50 transition-colors duration-300 font-medium"
        onClick={toggleMainMenu}
      >
        {item.label}
      </Link>
    </div>
  );
};

const MobileMenu = ({ isOpen, menuItems, toggleMenu }) => {
  if (!isOpen) return null;
  
  return (
    <div className="lg:hidden">
      <div 
        className="fixed inset-0 bg-black bg-opacity-25 z-20 backdrop-blur-sm transition-opacity duration-300"
        onClick={toggleMenu}
      ></div>
      
      <div className="absolute top-full left-0 right-0 max-h-[80vh] overflow-y-auto bg-white shadow-xl rounded-b-xl z-30 transform transition-all duration-300 animate-slide-in-down">
        {menuItems.map((item, index) => (
          <MobileMenuItem key={index} item={item} toggleMainMenu={toggleMenu} />
        ))}
      </div>
    </div>
  );
};

export default MobileMenu;